function getCompAppData(documentServices, componentType) {
  return documentServices.builder.components.getCompAppData(componentType)
}

export default {
  getCompAppData,
}
